import React, { useState } from "react";
import { Link } from "react-router-dom";
import validator from "validator";
import { forgotPwd, verifyOTP } from "../../services/ApiServices";
import toast from "react-hot-toast";
import OTPInput from "react-otp-input";
import logo from '../../assets/img/logo.png';
const OtpModal = ({ setOpenOTP, email, setOpenResetPwd, otp, setOTP, forgotEmailId }: any) => {

    const [isLoading, setIsLoading] = useState(false);
    const validation = (e: any) => {
        e.preventDefault();
        if (!otp) {
            toast.error("OTP is required")
            return;
        }
        if (otp && otp.length < 4) {
            toast.error("Please enter valid OTP")
        }
        verifyOTPApiCall()
    }

    const verifyOTPApiCall = () => {
        setIsLoading(true);
        verifyOTP({ email: forgotEmailId, token: otp }).then((res) => {
            console.log("forgot password", res);
            if (res.status === "success") {
                toast.success(res.message)
                setIsLoading(false);
                // setOTP("");
                setOpenOTP(false);
                setOpenResetPwd(true);
            } else if (res.status === "error") {
                setIsLoading(false);
                toast.error(res.error)
            }

        }).catch((err) => {
            setIsLoading(false);
            console.log("forgot password error", err);
            toast.error("something went wrong");
        })
    }

    return (
        <>
            <div className="card border-0 rounded-4">

                <div className="simple-form">
                    <div className="form-header text-center mb-5">
                        <h4 className="fs-2">Verify OTP</h4>

                        <div className="effco-logo mb-2">
                            <Link className="d-flex align-items-center justify-content-center" to="/">
                                <img src={logo} height={50} width={"40%"} />
                            </Link>
                        </div>
                    </div>
                    <form>
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                {`We’ve sent a 4-digit code to your email (${forgotEmailId}). Please check your inbox.`}
                                <div className="form-group mb-3">
                                    <label className='mb-2'>OTP</label>
                                    <OTPInput
                                        value={otp}
                                        shouldAutoFocus={true}
                                        onChange={(otp) => setOTP(otp)}
                                        numInputs={4}
                                        inputStyle={{
                                            height: 55,
                                            width: "100%",
                                            marginRight: "2%",
                                            border: "2px solid #E0E2E9",
                                            borderRadius: "5px",
                                            fontSize: '16px',
                                        }}
                                        renderInput={(props) => <input {...props} required />}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <button
                                type="submit"

                                className="btn btn-primary full-width fw-medium"
                                onClick={(e) => validation(e)}
                            >
                                {isLoading ? "Verifying..." : <>Verify<i className="fa-solid fa-arrow-right-long ms-2"></i></>}
                            </button>
                        </div>
                    </form>
                </div >
            </div >
        </>
    )
};

export default OtpModal;
